<canvas
  #canvas
  class="sdk-viewer__canvas"
  tabindex="0"
  (pointerdown)="onCanvasPointerDown($event)"
  (click)="onCanvasClick($event)"
></canvas>
<form class="sdk-viewer__panel" (submit)="$event.preventDefault(); open(sceneId)">
  <input
    class="sdk-viewer__scene"
    type="text"
    placeholder="Scene id"
    aria-label="Scene id"
    [value]="sceneId"
    (input)="onSceneInput($event)"
  />
  <button type="submit">Open</button>
  <span class="sdk-viewer__status">{{ status }}</span>
  <span *ngIf="selectedNodeId !== null" class="sdk-viewer__selection">Node {{ selectedNodeId }}</span>
  <span *ngIf="error !== null" class="sdk-viewer__error">{{ error }}</span>
</form>
